import { render } from "./InspectorExplanationDialog.vue?vue&type=template&id=28b92a40"
import script from "./InspectorExplanationDialog.vue?vue&type=script&lang=js"
export * from "./InspectorExplanationDialog.vue?vue&type=script&lang=js"

import "./InspectorExplanationDialog.vue?vue&type=style&index=0&id=28b92a40&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});qInstall(script, 'directives', {ClosePopup});
